module.exports = __webpack_public_path__ + "img/kgd_logo.52098b60.png";